const $ = jQuery;
const ToTopButton = {
    init: function() {
      this.toTopBtn = document.getElementById("toTopBtn");
      this.setupScrollListener();
      this.setupClickListener();
    },
  
    setupScrollListener: function() {
      window.onscroll = function() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          this.toTopBtn.style.display = "block";
        } else {
          this.toTopBtn.style.display = "none";
        }
      }.bind(this); // Binding 'this' da bismo koristili 'toTopBtn' unutar funkcije
    },
  
    setupClickListener: function() {
      this.toTopBtn.addEventListener("click", function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  };
  
  export default ToTopButton;
  